// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"143":"3cf0a827","317":"66c69ac0"}[chunkId] + ".chunk.css";
};